/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */
import React, { createContext, useState, useMemo } from 'react'
import PropTypes from 'prop-types'

export const AppContext = createContext(null)

const AppContextProvider = (props) => {
  const [lotteryState, setLotteryState] = useState(null)
  const [packageState, setPackageState] = useState(null)
  const [salesType, setSalesType] = useState(null)
  const [ticketIds, setTicketIds] = useState(null)
  const [ticketCount, setTicketCount] = useState(1)
  const valueProvider = useMemo(() => ({
    lotteryState,
    setLotteryState,
    packageState,
    setPackageState,
    salesType,
    setSalesType,
    ticketIds,
    setTicketIds,
    ticketCount,
    setTicketCount
  }), [lotteryState, packageState, salesType, ticketIds, ticketCount])

  return (
    <AppContext.Provider value={valueProvider}>
      {props.children}
    </AppContext.Provider>
  )
}

AppContextProvider.propTypes = {
  children: PropTypes.element
}

export default AppContextProvider
